// src/components/StoreSettingsWizard/PaymentsTab.jsx
import React from "react";
import { useFormContext } from "react-hook-form";
import { CURRENCIES } from "./constants/index";
import BaseCurrencySelect from "./common/BaseCurrencySelect"; // ← adjust path

export default function PaymentsTab() {
  const { register, setValue, watch, formState: { errors } } = useFormContext();
  const val = watch("payments.currency");

  return (
    <section className="grid gap-6 sm:grid-cols-2">
      {/* Currency */}
      <div>
        <BaseCurrencySelect
          label="Preferred Currency"
          value={val}
          onChange={(code) =>
            setValue("payments.currency", code, { shouldDirty: true, shouldValidate: true })
          }
        />
        {errors?.payments?.currency && (
          <p className="text-xs text-red-600 mt-1">
            {errors.payments.currency.message}
          </p>
        )}
      </div>

      {/* Notification email */}
      <div>
        <label className="block text-sm font-medium">
          Order Notification Email *
        </label>
        <input
          type="email"
          {...register("payments.notificationEmail")}
          placeholder="orders@example.com"
          className="mt-1 w-full rounded border p-2"
        />
        {errors?.payments?.notificationEmail && (
          <p className="text-xs text-red-600 mt-1">
            {errors.payments.notificationEmail.message}
          </p>
        )}
      </div>

      {/* Contact info */}
      <div>
        <label className="block text-sm font-medium">Contact Email *</label>
        <input
          type="email"
          {...register("payments.contactEmail")}
          placeholder="support@example.com"
          className="mt-1 w-full rounded border p-2"
        />
        {errors?.payments?.contactEmail && (
          <p className="text-xs text-red-600 mt-1">
            {errors.payments.contactEmail.message}
          </p>
        )}

        <label className="mt-4 block text-sm font-medium">Contact Phone *</label>
        <input
          type="tel"
          {...register("payments.contactPhone")}
          placeholder="+1 555-123-4567"
          className="mt-1 w-full rounded border p-2"
        />
        {errors?.payments?.contactPhone && (
          <p className="text-xs text-red-600 mt-1">
            {errors.payments.contactPhone.message}
          </p>
        )}
      </div>
    </section>
  );
}
